import React from 'react';
import './ArchiveButton.css';
import _ from 'lodash';
import Logger from '../util/Logger';
import Ideas from '../models/Ideas';
import { ideaApi } from '../api/IdeaApi';
import Comments from '../models/Comments';
import { commentApi } from '../api/CommentApi';
import ArchivedTracker from './ArchivedTracker';
import { TrackingAnalytics } from '../analytics/TrackingAnalytics';
import PayMeModal from '../money/PayMeModal';

export class ArchiveButton extends React.Component {

  static getButtonId (id) {
    return `archive-button-${id}`;
  }

  state = {
    showPayMeMoney: false
  }

  onHideModal = () => {
    this.setState({ showPayMeMoney : false });
  }

  handleClick = ($event) => {
    $event.preventDefault();
    $event.stopPropagation();

    const { user } = this.props;
    const paid = _.get(user, 'plan.features.moderation') || false;
    if (!paid) {
      this.setState({ showPayMeMoney : true });
      return;
    }

    const { idea, comment } = this.props;
    if (!!idea) {
      this.archiveIdea(idea);
      return;
    }

    if (!!comment) {
      this.archiveComment(comment);
      return;
    }
  };

  archiveIdea = (idea) => {
    Logger.info(`Archive clicked for idea: `, idea);
    ArchivedTracker.add(idea.id);

    // Promise does not need to be handled with any callback to PresentationPage since pusher should
    // broadcast the event.
    ideaApi.archive(Ideas.getId(idea)).then(deleted => {
      Logger.info('Idea was archived: ', deleted);
      TrackingAnalytics.gtag('Archived', {
        idea_id: Ideas.getId(idea)
      });
      TrackingAnalytics.send('Archived', {
        idea_id: Ideas.getId(idea)
      });
    }).catch(err => {
      Logger.error('Failed to archived idea: ', err);
      // TODO do we need to do anything on the UI?
    });
  };

  archiveComment = (comment) => {
    Logger.info(`Archive clicked for comment: `, comment);

    // Promise does not need to be handled with any callback to PresentationPage since pusher should
    // broadcast the event.
    commentApi.archive(Comments.getId(comment)).then(deleted => {
      Logger.info('Comment was archived: ', deleted);
      TrackingAnalytics.gtag('Archived', {
        comment_id: Comments.getId(comment)
      });
      TrackingAnalytics.send('Archived', {
        comment_id: Comments.getId(comment)
      });
    }).catch(err => {
      Logger.error('Failed to archived comment: ', err);
      // TODO do we need to do anything on the UI?
    });
  };

  render () {
    const { showPayMeMoney } = this.state;
    const { id, user, idea, comment, className } = this.props;

    const moderationEnabled = !!_.get(user, 'features.MODERATION');
    if (!moderationEnabled) {
      // Feature flag is off
      return null;
    }

    if (idea == null && comment == null) {
      // Missing stuff, cannot render
      return null;
    }

    if (idea != null) {
      if (!Ideas.canArchive(idea) && !Ideas.canDelete(idea)) {
        // Don't render anything if this cannot be archived.
        return null;
      }
    }

    if (comment != null) {
      if (!Comments.canArchive(comment) && !Comments.canDelete(comment)) {
        // Don't render anything if this cannot be archived.
        return null;
      }
    }

    return (
      <div className={ `presentation-archive-button rounded ${!!className ? className : ''}` }>
        <div id={ ArchiveButton.getButtonId(id) } className="clickable row no-gutters" onClick={ this.handleClick }>
          <span>Archive</span>
          <i className="ml-1 material-icons">archive</i>
        </div>

        { showPayMeMoney && <PayMeModal user={ user } onHidden={ this.onHideModal } /> }
      </div>
    );
  }
}
